import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
// import $ from '../common/jquery';
// import IScroll from '../common/iscroll-zoom';
// import PinchZoom from 'pinch-zoom-js';
import app from '../common/etool';
// require('../style/index.css')
import {
    View,
    Image,
    Keyboard,
    TextInput,
    KeyboardAvoidingView,
    TouchableWithoutFeedback,
    ScrollView,
} from 'react-native';

import CryptoJS from 'crypto-js';

import {
	JDTextInput,
	JDMta,
	JDText,
	JDImage,
	JDTouchable,
	JDAlertDialog,
	JDNativeSystem,
	JDConfirmDialog,
	JDScrollView, JDLogin

} from '@jdreact/jdreact-core-lib';

import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import ViewTransformer from '../components/view-transformer/transform/ViewTransformer';

import SingleButtonDialog from '../components/common/singleButtonDialog.js';
import {
    tip,
    complement,
    trim_time,
    ms_to_week,
    mta,
    mtaPV,
    decrypt,
    encrypt,
    routeEncryption,
    moneyHandle,
    pt,
		is_web,
		saveLocal,
		fetchLocal
} from '../common/utils';

import { get, post, signPost } from '../common/fetch';
import Dashed from '../components/dashed';
import Loading from '../components/common/loading';
import netImg from '../common/netImg';
import st from '../style/seat.st';
import VerifyPop from '../components/seat/verify';
import { setLog } from '../common/log';
import call from '@jd/call/lib';
import sgmReport from '../common/sgmUtil';

let maxLine = 0;
let has_tip = false;
let is_jump = false;
let recom_sel = false;
let submit = false;
let isIOS = false;

// 新的座位分布图
const newImg = {
    optimize: "https://storage.360buyimg.com/pandoracdn/movie/image/youxuan.png", // 优选
    select: "https://storage.360buyimg.com/pandoracdn/movie/image/jingxuan.png", // 精选
    carefullyChosen: "https://storage.360buyimg.com/pandoracdn/movie/image/texuan.png", // 特选
    boutique: "https://storage.360buyimg.com/pandoracdn/movie/image/jingping.png", // 精品
    environment: "https://storage.360buyimg.com/pandoracdn/movie/image/huanbao.png", // H环保
    vip: "https://storage.360buyimg.com/pandoracdn/movie/image/vip.png", // VIP
    lovers: "https://storage.360buyimg.com/pandoracdn/movie/image/qinglv.png", // 情侣
    lovers_disabled: "https://storage.360buyimg.com/pandoracdn/movie/image/lovers_disabled.png", // 情侣不可
    optimum: "https://storage.360buyimg.com/pandoracdn/movie/image/zuijia.png", // 最佳观影区
    screen: "https://storage.360buyimg.com/pandoracdn/movie/image/yingmu.png", // 荧幕
    sold: "https://storage.360buyimg.com/pandoracdn/movie/image/yishou.png", // 已售
    chose: "https://storage.360buyimg.com/pandoracdn/movie/image/kexuan.png", // 可选
    notOptional: "https://storage.360buyimg.com/pandoracdn/movie/image/bukexuan.png", // 不可选
}
/**
 * 获取颜色格子
 * @param key 索引
 * @param total 总条数
 * @param db 是否是情侣座
 * @returns string
 */
const getColor = (key, total = 9, db = false) => {
    if (key >= 10) key = 10;
    let number = key + 1;
    // 最后一个显示白色
    if (key === total-1) number = 10;
    return db
        ? `https://storage.360buyimg.com/pandoracdn/movie/image/lovers/${number}.png`
        :  `https://storage.360buyimg.com/pandoracdn/movie/image/seat/${number}.png`
}
// 名称
const newTitle = {
    optimize: "优选座", // 优选
    select: "精选座", // 精选
    carefullyChosen: "特选座", // 特选
    boutique: "精品座", // 特选
    environment: "环保座", // H环保
    vip: "VIP座", // VIP
    lovers: "情侣座", // 情侣
    optimum: "最佳观影区", // 最佳观影区
}
// 画布缩放比例
const canvasZoom = 1.4
// 入口文件
class Seat extends PureComponent {
    constructor(props) {
        super(props);
        this.txtSMRZ = '电影局最新要求实名制购票，未进行实名认证则无法购买电影票\n\n当前帐号未实名认证，请在京东APP-【我的】-【账户设置】-【实名认证】进行实名信息认证，实名认证后可进行选座购票';
        this.isRealName = true; // 是否需要实名制购票 true需要 false走原流程
        this.isVerifyAuthUser = true; // 用户是否已实名，isRealName未true时校验此字段， true展示底部实名文案，false 弹出提示用户需实名
        this.verifyMsg = {};
        this.state = {
            showMobile: false,
            row_len: 0,
            data: null,
            has_db: false,
            seat_img: null,
            erpOrderId: null,
            show_pay: false,
            show_best: false,
            show_recom: false,
            show_alert: false,
            show_confirm: false,
            show_back_confirm: false,
            show_lockError: true,
            showRzAlert: true,
            showVerifyPop: false,
            isRealName: false,
            isVerifyAuthUser: false,
            verifyMsg: {},
            openPartition: false, // 是否有分区
            seatPartition: [], // 分区价格表
            seatOrientation: true, // 默认出口在屏幕左侧
	          releasePop: true, // 是否显示释放弹窗
	          limitNumber: 0,
		        seatsData: [], // 原始座位数据
		        minTicketNum: 0,
		        stopSaleMinute: ""
        };
        this.has_req = false;
        this.confirm_back = false;
        this.recom = this.recom.bind(this);
        this.get_data = this.get_data.bind(this);
        this.show_pay = this.show_pay.bind(this);
        this.sel_seat = this.sel_seat.bind(this);
        this.recom_core = this.recom_core.bind(this);
        this.close_alert = this.close_alert.bind(this);
        this.btm_show_alert = this.btm_show_alert.bind(this);

        this.show_back_confirm = false;
    };
    render() {
        const {
            showMobile,
            data,
            row_len,
            show_recom,
            show_alert,
            show_confirm,
            show_back_confirm,
            seat_img,
            has_db,
            show_best,
            show_pay,
            showRzAlert,
            showVerifyPop,
            isRealName,
            isVerifyAuthUser,
            verifyMsg,
            openPartition,
            seatPartition,
            seatOrientation,
	          limitNumber,
		        seatsData,
		        minTicketNum,
		        stopSaleMinute
        } = this.state;
        const { acList, title, show_loading, show_lockErrorPop, show_pop, govSubsidy } = this.props;
        return (
            <View style={ st.container }>
                {!is_web ? <NavBar title={ title && title.length > 10 ? decodeURI(title).slice(0, 10) + '...' : decodeURI(title) } /> : this.setTitle(decodeURI(title))}
                {/* <NavBar title={title && title.length > 10 ? decodeURI(title).slice(0, 10) + '...' : decodeURI(title)} /> */}

                <Info
	                { ...this.props }
	                has_db={ has_db }
	                show_best={ show_best }
	                minTicketNum={minTicketNum}
	                stopSaleMinute={stopSaleMinute}
                />
                {/*选座区域*/}
                <SeatList
                    data={ data }
                    acList={ acList }
                    row_len={ row_len }
                    sel_seat={ this.sel_seat }
                    seat_img={ seat_img }
                    openPartition={ openPartition }
                    seatPartition={ seatPartition }
                    has_db={ has_db }
                    show_best={ show_best } />
                {/*底部座位及结算区域*/}
                <Bottom
                    { ...this.props }
                    showMobile={showMobile}
                    price={ data && data.jdPrice }
                    selectSeats={ data && data.selectSeats }
                    data={ data }
                    del={ this.sel_seat }
                    show_recom={ show_recom }
                    recom={ this.recom }
                    promotion={ data && data.moviePromotionVO }
                    show_alert={ this.btm_show_alert }
                    show_pay={ this.show_pay }
                    openVerifyPop={ this.openVerifyPop }
                    verifyMsg={ this.verifyMsg }
                    openPartition={ openPartition }
                    seatOrientation={ seatOrientation }
                    seatsData={seatsData}
                    isTipShow={ isVerifyAuthUser && isRealName }
                />

                <JDAlertDialog show={ show_alert } onClose={ this.close_alert } >
                    <View style={ st.wrap_alert_text }>
                        <JDText style={ st.confirm_text }> {this.alert_txt} </JDText>
                    </View>
                </JDAlertDialog>

                <JDConfirmDialog
                    show={ show_confirm }
                    confirmText='暂不选择'
                    cancelText='继续选择'
                    onCancel={ () => this.close_confirm() }
                    onConfirm={ () => this.close_confirm(true) }>
                    <View style={ st.wrap_confirm_text }>
                        <JDText style={ st.confirm_text }>
                            {`购买超过${(data && data.moviePromotionVO) ? limitNumber : ''}张票, 本订单将不再享受优惠, 继续选择此座位吗?`}
                        </JDText>
                    </View>
                </JDConfirmDialog>

                <SingleButtonDialog
                    show={ show_lockErrorPop }
                    cancelText='确认'
                    onCancel={ () => this.close_confirmlockError() }
                >
                    <View style={ st.wrap_confirm_text }>
                        <JDText style={ st.confirm_text }>
                            影院排期已变更，请稍后重试！
                        </JDText>
                    </View>
                </SingleButtonDialog>

                <JDConfirmDialog
                    show={ show_back_confirm || this.show_back_confirm || show_pop }
                    confirmText='确定'
                    cancelText='取消'
                    onCancel={ () => this.close_back_confirm() }
                    onConfirm={ () => this.close_back_confirm(true) }
                >
                    <View style={ st.wrap_confirm_text }>
                        <JDText style={ st.confirm_text }>是否确认返回，如返回座位将被释放</JDText>
                    </View>
                </JDConfirmDialog>

                <JDConfirmDialog
                    show={ show_pay }
                    confirmText='支付订单'
                    cancelText='取消订单'
                    onCancel={ () => this.close_pay() }
                    onConfirm={ () => this.close_pay(true) }
                >
                    <View style={ st.wrap_confirm_text }>
                        <JDText style={ st.confirm_text }>您有未支付订单，请先行处理</JDText>
                    </View>
                </JDConfirmDialog>

                <View style={ {
                    height: JDNativeSystem.iphoneXMarginBottom,
                    backgroundColor: '#fff',
                    width: '100%'
                } } />

                {show_loading
                    ? <View style={ st.wrap_loading }>
                        <View style={ st.loading_con }>
                            <JDImage style={ st.loading_img } source={ { uri: netImg.seat_loading } } />
                            <JDText style={ st.loading_text }>锁座中</JDText>
                        </View>
                    </View>
                    : null}

                {isRealName && !isVerifyAuthUser &&
                    <Alert
                        title='实名认证'
                        show={ showRzAlert }
                        content={ this.txtSMRZ }
                        confirmText='我知道了'
                        onConfirm={ this.iKnow }
                    />
                }
                {/* {isRealName&&!isVerifyAuthUser&& */}
                {showVerifyPop &&
                    showVerifyPop && <VerifyPop
                    show={ showVerifyPop }
                    onHide={ this.onHide }
                    verifyMsg={ this.verifyMsg }
                />}

                {isRealName && !isVerifyAuthUser &&
                    <Alert
                        title='实名认证'
                        modalShow={ showRzAlert }
                        content={ this.txtSMRZ }
                        confirmText='我知道了'
                        onConfirm={ this.iKnow }
                    />
                }
                {/* {isRealName&&!isVerifyAuthUser&& */}
                {showVerifyPop &&
                    showVerifyPop && <VerifyPop
                    show={ showVerifyPop }
                    onHide={ this.onHide }
                    verifyMsg={ this.verifyMsg }
                />
                }
                {/* {isRealName&&!isVerifyAuthUser&& */}
                {showVerifyPop &&
                    showVerifyPop && <VerifyPop
                    show={ showVerifyPop }
                    onHide={ this.onHide }
                    verifyMsg={ this.verifyMsg }
                />
                }

            </View>
        );
    }

    setTitle = (title) => {
        document.title = title;
    }

    componentDidMount() {
		    JDLogin.isLogin().then(() => {
			    console.log('登录成功')
		    }, () => {
					// 跳转去登录
			    JDLogin.doLogin();
		    })
        // this.getVerify();
        this.get_data();
        setTimeout(() => {
            this.has_req = true;
        }, 500);
        const _this = this;
        // this.show_back_confirm = true
        this.props.dispatch({
            type: 'show_pop',
            show_pop: false
        });
    }

    pushHistory() {
        const state = {
            title: 'title',
            url: '#'
        };

        window.history.pushState(state, 'title', '#');
    }

    pushHistory() {
        const state = {
            title: 'title',
            url: '#'
        };

        window.history.pushState(state, 'title', '#');
    }
    componentDidFocus() {
        if (this.has_req) {
            this.get_data();
        };
        is_jump = false;
        submit = false;
        this.props.dispatch({ type: 'show_loading', show_loading: false });

        mtaPV('Positon');
    }
    componentWillUnfocus() {
        const { data } = this.state;
        if (data && data.selectSeats && !this.confirm_back && !is_jump) {
            this.props.dispatch({
                type: 'show_pop',
                show_pop: true
            });
            this.setState({ show_back_confirm: true });

            return true;
        };
    }

    deleteAllCache (){
		    if (is_web) {
				    localStorage.removeItem('partition')
				    localStorage.removeItem('seatsGroup')
				    localStorage.removeItem('promoInfo')
				    localStorage.removeItem('acList');
				    // 进入选座页面则删除上次默认选择的优惠券
				    this.props.dispatch({type: 'cert_info_change', certInfo: []});
		    } else {
				    // 页面销毁后删除缓存数据
				    this.props.dispatch({ type: 'acList', acList: [] });
				    this.props.dispatch({ type: 'partition', partition: false });
				    this.props.dispatch({ type: 'seatsGroup', seatsGroup: [] });
				    this.props.dispatch({ type: 'promoInfo', acList: [] });
		    }
    }

    componentWillUnmount() {
    	  // 是否显示释放的弹窗;
    	  if (this.state.releasePop) {
		      this.show_back_confirm = true;
	      }
        const { data } = this.state;
        const { planId } = this.props;


        is_jump = false;
        // if (data && data.selectSeats && !this.confirm_back && !is_jump) {
        //     alert('comming')
        //     this.setState({ show_back_confirm: true });
        //     alert(show_back_confirm)
        //     this.show_back_confirm = true
        //     return true;
        // }
        // else 为了解决新H5第二次进填单页重新请求的bug
        saveLocal('selectedSeat', data?.selectSeats);
        saveLocal('planId', planId);
        // if (data && data.selectSeats && !this.confirm_back) {
        //     let selectedSeat = data.selectSeats;
        //     get('releaseSeat', { planId, selectedSeat }).then((res) => { });
        // };
    }
    iKnow = () => {
        this.setState({
            showRzAlert: false
        });
        this.context.router.goBack();
    }
    onHide = () => {
        this.setState({
            showVerifyPop: false
        });
    }
    openVerifyPop = () => {
        // this.setState({
        //     showVerifyPop: !this.state.showVerifyPop
        // })
        this.getVerify();
    }
    show_pay(erpOrderId) {
        this.setState({
            show_pay: true,
            erpOrderId
        });
    }
    close_pay(is_pay) {
        const { erpOrderId, data } = this.state;

        this.setState({
            show_pay: false
        }, () => {
            if (is_pay) {
                is_jump = true;
                this.context.router.replace({
                    routeName: 'orderDetail',
                    props: {
                        erpOrderId,
                        movieId: data.movieId
                    }
                });
            } else {
                post('cancelMovieOrder', { erpOrderId }, true).then(res => {
                    if (res.errCode - 0) {
                        tip('订单取消失败，请重新尝试');
                    } else {
                        tip('订单取消成功');
                    };
                }).catch(() => {
                    tip('订单取消失败，请重新尝试');
                });

                if(!erpOrderId){
                    sgmReport('1001', {function_id: 'cancelMovieOrder',message:'缺少参数erpOrderId'}, 3)
                }
            }
        });
    }
    close_back_confirm(confirm) {
        this.setState({
            show_back_confirm: false
        }, () => {
            if (confirm) {
                const { planId, scheduledPlay = "0" } = this.props;
                const { data } = this.state;
                const selectedSeat = data.selectSeats;
                get('releaseSeat', {
									planId,
	                selectedSeat,
	                scheduledPlay: +scheduledPlay
								}).then((res) => { });
                this.confirm_back = true;
                this.context.router.goBack();

                if(!planId){
                    sgmReport('1001', {function_id: 'releaseSeat',message:'缺少参数planId'}, 3)
                }
            };
        });
    }
    close_confirm(clear) {
        const { dispatch } = this.props;
        this.setState({
            show_confirm: false
        }, () => {
            if (!clear) {
                dispatch({
                    type: 'acList',
                    acList: this.confirm_aclist
                });
            };
        });
    }
    close_confirmlockError() {
        const { dispatch } = this.props;
        dispatch({
            type: 'show_lockErrorPop',
            show_lockErrorPop: false,
	          releasePop: false, // 不显示释放弹窗
        });
        this.context.router.goBack();
    }
    btm_show_alert() {
        this.alert_txt = '商家数据更新，请联系客服400-616-5718';
        this.alert_cb = () => { };
        this.setState({ show_alert: true });
    }
    close_alert() {
        this.setState({
            show_alert: false
        }, () => {
            this.alert_cb();
        });
    }
    recom(num) {
        const { outer, inner, db } = this;

        const { data } = this.state;

        const { promtId } = this.props;

        let single = 0;

        let db_num = 0;

        let list = [];

        let is_inner = true;

        Object.keys(inner).forEach((val) => {
            single += inner[val].length;
        });

        Object.keys(outer).forEach((val) => {
            single += outer[val].length;
        });

        Object.keys(db).forEach((val) => {
            db_num += db[val].length;
        });

        mta('PositionRecomm', 'Positon', `${data.cinemaId || ''}_${data.jSkuId || ''}_${data.movieId || ''}_${num}_${promtId || '-1'}`);

        if (num == 2 && db_num) {
            this.recom_db();

            return;
        };

        if (single < num) {
            tip('空余座位不足，请您手动选座');

            return;
        };

        list = this.recom_core(inner, num);

        if (!list.length) {
            is_inner = false;
            list = this.recom_core(outer, num);
        };

        if (list.length) {
            recom_sel = true;
            // this.sel_seat(list, is_inner && tip('恭喜您获得最佳观影位'));
		        list.map(value => {
				        setTimeout(_=> this.sel_seat(value, ''));
		        });
        } else {
            tip('暂未匹配到最佳座位，请手动选座');
        };
        try {
	        document.querySelector('.seat_map_wrapper').scrollLeft = document.querySelector('.seat_screen').offsetLeft - 100;
        } catch (e) {}

    }
    recom_db() {
        const { db } = this;

        const list_index = Object.keys(db).sort((a, b) => a - b);

        const cur = db[list_index[0]];

        const random = ~~(Math.random() * cur.length);

        let list;
        list = [cur[random]];

        tip('甜甜蜜蜜，赚到啦');

        recom_sel = true;

		    list.map(value => {
				    setTimeout(_=> this.sel_seat(value, ''));
		    });
    }
    recom_core(list, num) {
        const { data } = this.state;

        let index;

        let near_, near__, near___;

        const list_index = Object.keys(list).sort((a, b) => a - b);

        const len = list_index.length;

        const seats = data?.format;

        if (!len) return [];

        if (num == 1) {
            const cur = list[list_index[0]];

            const random = ~~(Math.random() * cur.length);

            return [cur[random]];
        };

        // 以下代码待优化
        // 以下代码待优化
        // 以下代码待优化
        if (num == 2) {
            for (index = 0; index < len; index++) {
                let i;

                const cur = list[list_index[index]];

                cur.sort(() => !(~~(Math.random() * 2)) ? -1 : 1);

                for (i = 0; i < cur.length; i++) {
                    const base = cur[i]?.format[0]?.split(':');

                    near_ = seats[base[0] - 1][base[1]];
                    if (near_ && near_?.format[2] == 0) {
                        return [cur[i], near_];
                    };
                    near_ = seats[base[0] - 1][base[1] - 2];
                    if (near_ && near_?.format[2] == 0) {
                        return [cur[i], near_];
                    };
                };
            };
        };

        if (num == 3) {
            for (index = 0; index < len; index++) {
                let i;

                const cur = list[list_index[index]];

                cur.sort(() => !(~~(Math.random() * 2)) ? -1 : 1);

                for (i = 0; i < cur.length; i++) {
                    let recom_index;

                    const base = cur[i]?.format[0]?.split(':');

                    const num = [[0, -2], [0, 1], [-2, -3]];

                    for (recom_index = 0; recom_index < num.length; recom_index++) {
                        near_ = seats[base[0] - 1][base[1] - 0 + num[recom_index][0]];
                        near__ = seats[base[0] - 1][base[1] - 0 + num[recom_index][1]];
                        if (near_ && near_?.format[2] == 0 && near__ && near__?.format[2] == 0) {
                            return [cur[i], near_, near__];
                        };
                    };
                };
            };
        };

        if (num == 4) {
            for (index = 0; index < len; index++) {
                let i;

                const cur = list[list_index[index]];

                cur.sort(() => !(~~(Math.random() * 2)) ? -1 : 1);

                for (i = 0; i < cur.length; i++) {
                    let recom_index;

                    const base = cur[i]?.format[0]?.split(':');

                    const num = [[0, 1, -2], [0, -2, -3], [0, 1, 2], [-2, -3, -4]];

                    for (recom_index = 0; recom_index < num.length; recom_index++) {
                        near_ = seats[base[0] - 1][base[1] - 0 + num[recom_index][0]];
                        near__ = seats[base[0] - 1][base[1] - 0 + num[recom_index][1]];
                        near___ = seats[base[0] - 1][base[1] - 0 + num[recom_index][2]];
                        if (near_ && near_?.format[2] == 0 && near__ && near__?.format[2] == 0 && near___ && near___?.format[2] == 0) {
                            return [cur[i], near_, near__, near___];
                        };
                    };
                };
            };
        };

        return [];
        // 以上代码待优化
        // 以上代码待优化
        // 以上代码待优化
    }

    /**
     * 选座被点击
     * @param sel
     * @param tip_str
     */
    sel_seat(sel, tip_str) {
    	  const currentSeat = sel;
        const { dispatch, acList, promtId } = this.props;
        const { data, show_best, seatPartition, openPartition } = this.state;
        const seats = data?.format;
        const temp = JSON.parse(JSON.stringify(acList));
        let num = 0;
        let cancel = false;
        sel = [].concat(sel);
        // if (this.sel_able == 0) { tip('很抱歉，场次已售空，请选择其它场次'); return };
        // Keyboard.dismiss();

        sel.forEach((val) => {
            let index = -1;
            const formatTow = +val?.format[2];
            if ((formatTow === 1 || formatTow === 13) && !val.self_select) return;
            // 新增的不可用 禁止选中[过道, 情侣座不可用]
            if ([5, 23, 24].includes(formatTow)) return ;
            acList.forEach((value, key) => {
                (value.meta === val.meta) && (index = key);
            });
            if (index >= 0) {
                cancel = true;
                temp.splice(index, 1);
                mta('PositionDelete', 'Positon', `${promtId}` || '-1');
            } else {
                // [若是开启了分区] 查找架构信息并且写入
                this.preferentialTreatment(val, temp);
                temp.push(val);
            }
        });
        temp.forEach((val) => {
            num += ((val?.format[2] == 3 || val?.format[2] == 13) ? 2 : 1);
        });
        if (num > 4) {
            tip('一次最多购买4张');
            return;
        };
        if (temp.length > 1) {
            const line = {};
            let block = false;
            temp.forEach((val) => {
                const cur = val?.format[0]?.split(':');
                if (val.db_meta) { return; };
                if (line[cur[0]]) {
                    line[cur[0]].push(cur);
                } else {
                    line[cur[0]] = [cur];
                };
            });

            // 判断是否单独留座
            Object.keys(line).forEach((val) => {
                let i;
                const line_item = line[val];
                if (line_item.length === 1) return;
                line_item.sort((a, b) => a[1] - b[1]);
                for (i = 0; i < line_item.length - 1; i++) {
                    const line = line_item[i][0] - 1;
                    const right = seats[line][line_item[i + 1][1] - 1];
                    const near_ = seats[line][line_item[i][1]];
                    const near__ = seats[line][line_item[i][1] - 0 + 1];
                    if (near_?.format[2] == '0' && near__ && (near__.meta == right.meta)) {
                        block = true;
                    };
                };
            });
            if (block) {
                tip(cancel ? '请不要留单独座位' : '请选择相邻的座位');
                return;
            }
        };

        // 获取当前分区限制的最大张数!
	      const aid = currentSeat?.format[3] || -1;
	      const info = seatPartition.find(value=> value.agentSeatAreaId === aid);
	      console.log('座位信息', info)
		    // 获取当前分区限制的最大张数!
		    let condition = '';  // 显示弹窗的条件
		    let limitNumber = 5;
		    if (openPartition) {
				    // 获取当前分区限制的最大张数!
				    let limit =  []
				    // 根据活动 id 过滤出 新的活动数组
				    seatPartition.map((value, index, array) => {
						    const is = limit.findIndex(val=> val.actId === value.actId);
						    if (is === -1) limit.push(value);
				    });
				    limit.map((val, index)=> {
						    limit[index].total = 0;
						    // 根据选择的影片统计出现的次数
						    temp.map(value => {
								    if (value.showDiscountId === val.actId) {
										    if (val.total) {
												    limit[index].total++
										    } else {
												    limit[index].total = 1;
										    }
								    }
						    })
				    })
				    // 根据当前的分区查找当前活动的优惠信息
				    const aid = currentSeat?.format[3] || -1;
				    // 在优惠活动中查找当前区域
				    const info2 = seatPartition.find(value => value.agentSeatAreaId === aid)
				    if (info2) {
						    // 查找当前所属的活动
						    const info = limit.find(value => value.actId === info2.actId)
						    if (info) {
								    condition = info.total > info.limitNumber;
								    limitNumber = info.limitNumber;
						    }
						    console.log('info', info, condition, limitNumber);
				    }
		    } else {
				    condition = num > (data.moviePromotionVO ? data.moviePromotionVO.limitNumber : 5);
		    }
		    console.log('condition', condition);
		    if (condition) {
				    if (!has_tip) {
						    this.confirm_sel = sel;
						    this.confirm_aclist = temp;
						    if (openPartition) {
								    this.limitNumber = limitNumber;
						    } else {
								    this.limitNumber = data.moviePromotionVO.limitNumber - 0;
						    }
						    if (this.limitNumber) {
								    this.setState({ show_confirm: true, limitNumber: this.limitNumber   });
								    has_tip = true;
								    return;
						    }
				    } else {
						    (show_best && tip_str) && tip(tip_str);
				    }
		    }
		    else {
				    (show_best && tip_str) && tip(tip_str);
		    }

        // show_gif = true;
        // 更新座位信息
        setLog().name('更新座位信息').add(temp)
        dispatch({
            type: 'acList',
            acList: temp
        });
    }

    set_weight() {
        const { data, row_len } = this.state;

        const outer = {};

        const inner = {};

        const db = {};

        const col_len = data?.format.length;

        const row_num = ~~(row_len * 0.6);

        const col_num = ~~(col_len / 3);

        const row_left_num = Math.ceil(row_len * 0.2);

        const col_top_num = Math.ceil(col_len / 3);

        const center_x = row_num % 2 ? [row_num / 2 - 0.5 + row_left_num] : [row_num / 2 - 1 + row_left_num, row_num / 2 + row_left_num];

        const center_y = col_num % 2 ? [col_num / 2 - 0.5 + col_top_num] : [col_num / 2 - 1 + col_top_num, col_num / 2 + col_top_num];

        data?.format.forEach((val, index_y) => {
            val.forEach((val, index_x) => {
                let level;

                let diff_x = Infinity;

                let diff_y = Infinity;

                const cur_num = val?.format[0]?.split(':');

                if (val?.format[2] == 3) {
                    index_x = (index_x + 0.5) * 2;
                };

                center_x.forEach((val) => {
                    const cur = Math.abs(val - index_x);

                    if (cur < diff_x) { diff_x = cur; };
                });

                center_y.forEach((val) => {
                    const cur = Math.abs(val - index_y);

                    if (cur < diff_y) { diff_y = cur; };
                });

                level = diff_x * diff_x + diff_y * diff_y;

                if (val?.format[2] == 0) {
                    if ((cur_num[0] > col_top_num && cur_num[0] <= col_top_num + col_num) && (cur_num[1] > row_left_num && cur_num[1] <= row_left_num + row_num)) {
                        if (inner[level]) {
                            inner[level].push(val);
                        } else {
                            inner[level] = [val];
                        };
                    } else {
                        if (outer[level]) {
                            outer[level].push(val);
                        } else {
                            outer[level] = [val];
                        };
                    };
                };

                if (val?.format[2] == 3) {
                    if (db[level]) {
                        db[level].push(val);
                    } else {
                        db[level] = [val];
                    };
                };
            });
        });

        this.inner = inner;
        this.outer = outer;
        this.db = db;
    }


    /**
     * 优惠数据处理
     * @param val 当前处理的数据
     * @param temp 总的数据数组
     * @returns {*}
     */
    preferentialTreatment  (val, temp) {
		    const { seatPartition, openPartition, data } = this.state;
		    console.log('座位数据2', seatPartition, openPartition, val);
		    // 若是没有开启分区, 直接返回原来的数据
		    if (openPartition) {
				    // 第三位,分区价格
				    const formatRegion = val?.format[3] || -1;
				    // 如果分区存在优惠, 将词条输入插入
				    // 查找当前座位是否存在优惠
				    const zIndex = seatPartition.findIndex(value=> value.agentSeatAreaId === formatRegion);
				    if (zIndex !== -1) {
						    const info = seatPartition[zIndex];
						    const limitNumber = info?.limitNumber || 0; // 一共几张促销;
						    // 累加促销ID相同的座位数量;
						    const agentSeatAreaCount = temp.filter(value1 => +value1.showDiscountId === +info.actId).length; // 统计用了几张

						    const showPromotions = agentSeatAreaCount < limitNumber; // 小于张数的时候显示促销
						    val.discount = info; // 优惠数组信息
						    val.agentSeatAreaId = info.agentSeatAreaId; //促销ID
						    val.showDiscountId = info.actId; // 是不是促销活动, 显示 ID
						    val.showPromotions = showPromotions && +(info.actId) > 0; // 是否显示优惠
						    val.jdPrice = info.jdPrice; // 京东价(原价)
						    // 若是有优惠, 显示促销价, 否则显示京东价
						    val.price = showPromotions
							    ? +info.promotPrice  // 促销价
							    : +info.jdPrice; // 京东价
				    } else {
						    // 若是没有找到, 使用默认的价格, 追加
						    val.price = +data.jdPrice; // 原价
				    }
				    setLog().add(val)
		    }
		    return val;
    }


    getVerify = () => {
        post('userAuthInfo', {}).then((res) => {
            if (res.success) {
                this.verifyMsg = res.data;
                this.setState({
                    showVerifyPop: !this.state.showVerifyPop
                });
            }
        });
    }

    /**
     * 页面主接口
     */
    get_data() {
    		this.deleteAllCache(); // 每次打开页面都删除一次缓存
        const {
					dispatch,
	        planId,
	        promtId,
	        scheduledPlay = "0"
				} = this.props;
        signPost('getSeaPlanVO', {
            channel: global.channel || 1,
            planId: planId || 599721505,
            promtId: promtId || -1,
	          scheduledPlay: parseInt(scheduledPlay),
        }).then((res) => {
            let row_len = 0;
            const data = [];
            const acList = [];
            let all_db = true;
            let sel_able = 0;
            let self_num = 0;
            let has_db = false;
            let last_val_index = -1;
            // 处理实名制字段
            if (res?.data?.realName) {
                this.isRealName = res.data.realName;
                this.setState({
                    isRealName: res.data.realName,
                    isVerifyAuthUser: res.data.verifyAuthUser
                });

                if (!res.data.verifyAuthUser) {
                    if (res.errCode === 5000 || res.errCode === 6001) {
                        tip('系统有点忙，请稍后重试');
                        // this.context.router.goBack();
                        return;
                    };
                    if (res.errCode === 2200) {
                        tip('促销信息已更新，选座后即可查看');
                    };
                    if (res.errCode === 2401) {
                        this.alert_txt = '场次已过期，请重新选择场次';
                        // this.alert_cb = () => this.context.router.goBack();
                        this.alert_cb = () => { };
                        this.setState({ show_alert: true });
                        return;
                    };
                }
            }
            else {
                if (res.errCode === 5000 || res.errCode === 6001) {
                    tip('系统有点忙，请稍后重试');
                    // this.context.router.goBack();
                    return;
                };
                if (res.errCode === 2200) {
                    tip('促销信息已更新，选座后即可查看');
                };
                if (res.errCode === 2401) {
                    this.alert_txt = '场次已过期，请重新选择场次';
                    // this.alert_cb = () => this.context.router.goBack();
                    this.alert_cb = () => { };
                    this.setState({ show_alert: true });
                    return;
                };
            }
            const selectSeats = res.data.selectSeats ? res.data.selectSeats.split('|') : [];
		        // 0 横坐标,  1 真实座位号, 2 座位状态, 3 区域,  4座位号唯一标志,
            setLog().name('座位信息').add(res.data)
		        res.data.seats.forEach((meta, index, arr) => {
				        const format = meta?.split(';');
				        const seat_num = format[0]?.split(':');
				        const val_index = seat_num[0] - 1;
				        let db_meta = '';
				        // ?
				        let self_select = false;
				        let formatTwo = +format[2];
				        // 4 情侣右侧可售,  14 情侣座不可售
				        if (formatTwo === 4 || formatTwo === 14) return;
				        // 4 情侣左侧可售,  14 情侣座不可售
				        if (formatTwo === 3 || formatTwo === 13) {
						        has_db = true;
						        db_meta = arr[index + 1];
				        }

				        selectSeats.forEach((val) => {
						        const val_fmt = val?.split(';');
						        if (val_fmt[0] == format[1]) {
								        self_select = true;
								        self_num++;
								        // 已售(1)改成 0 可售
								        if (formatTwo === 1) {
										        format[2] = '0';
								        }
								        // 情侣左已售 改为 情侣左可售
								        if (formatTwo === 13) {
										        format[2] = '3';
								        }
								        // 后退还原需要写入优惠信息
								        const duplicateNot = acList.findIndex(value => value.meta ===  val.format);
								        // 防止写入重复数据
								        if (duplicateNot === -1) {
										        const config = {
												        meta,
												        format,
												        db_meta,
												        self_select
										        }
										        acList.push(config);
								        }
						        };
				        });

				        if (format[2] == 0 || format[2] == 1) all_db = false;
				        if (format[2] == 0 || format[2] == 3) {
						        sel_able++;
				        };
				        if (seat_num[1] - 0 > row_len) {
						        row_len = seat_num[1];
				        };
				        if (val_index < last_val_index) {
						        return;
				        } else {
						        last_val_index = val_index;
				        };
				        if (data[val_index]) {
						        if (seat_num[1] - 0 > maxLine) {
								        maxLine = seat_num[1];
						        };
						        data[val_index].push({
								        meta,
								        format,
								        db_meta,
								        self_select
						        });
				        }
				        else {
						        data[val_index] = [{
								        meta,
								        format,
								        db_meta,
								        self_select
						        }];
				        };
		        });
            res.data.format = data;
            // 判断座位图顺序
            const seatsData = res.data.format;
            // 影院座位出口计算
            const direction = {
                clockwise: [], // 顺时针
                anti: [], // 逆时针
            };
            try {
              seatsData.forEach((value, index1) => {
                value.map((value, index) => {
                  if (index < (seatsData.length - 1)) {
                    const format = value.format[1]?.split(':');
                    const next = seatsData[index1][index + 1].format[1]?.split(':');
                    if (+format[1] < +next[1]) {
                      direction.clockwise.push(1)
                    } else {
                      direction.anti.push(1)
                    }
                  }
                })
              })
            }catch (e) {}


	        const seatPromotionVO = res.data?.seatPromotionVO;
	        const seatPartition =  seatPromotionVO?.seatPartitionVOList || []; // 分区数据
	        const { minTicketNum, stopSaleMinute = "" } = res?.data ?? {};

	        this.setState({
		          openPartition: !!seatPromotionVO?.isPartitionPrice || false, // 是否有分区
		          seatPartition: seatPartition.sort((a,b) => b.jdPrice - a.jdPrice),
		            // 大于等于是顺时针方向, 出口在左侧, 小于是逆时针方向, 出口在右侧!
		          seatOrientation: direction.clockwise.length >= direction.anti.length,
			        seatsData,
			        minTicketNum, // 开场要求的最低出票数量，低于该票数时本场次原则上不放映
			        stopSaleMinute,  // 截止时间字段
	        }, _=> {
		        // 还原优惠及处理
		        acList.map((value, index) => acList[index] = this.preferentialTreatment(value, acList));
		        dispatch({ type: 'acList', acList });
	        });


	        if (!is_web) {
	        		// web 平台不显示此数据
			        get('getSeatAdByMovieId', { movieId: res.data.movieId }).then((res) => {
					        this.setState({
							        seat_img: res.data
					        });
			        });

                    if(!res.data.movieId){
                        sgmReport('1001', {function_id: 'getSeatAdByMovieId',message:'缺少参数movieId'}, 3)
                    }
	        }
          this.isShowMobile(res.data);
	        this.setState({
		        data: res.data,
		        row_len,
		        has_db
	        }, () => {
		        if (!sel_able) {
			        if (!res?.data?.realName || (res?.data?.realName && res?.data?.verifyAuthUser)) {
				        tip('很抱歉，场次已售空，请选择其它场次');
			        };
			        return;
		        };
		        // if (all_db) return;
		        this.setState({
			        show_recom: true,
			        // 最佳观影区显示
			        show_best: data.length >= 10 && res.data.bestMovieSwitch
		        }, () => {
			        this.sel_able = sel_able;
			        this.set_weight();
		        });
	        });
	        saveLocal('savemobile', res.data.mobile);
        });
    }

    isShowMobile = (data) => {
      const { mobile } = data || {};
        const { showMobile } = this.state;

        // 校验是否存在mobile，解密后是否合法
        if (mobile) {
            const mobile_decrypt = decrypt(mobile, 'y97c51kl38h8p144');

            if (/^[1]\d{10}$/g.test(mobile_decrypt)) {
                showMobile && this.setState({
                    showMobile: false
                });
                // 更新redux，用于填单页展示
                this.props.dispatch({ type: 'mobileNum', mobileNum: mobile_decrypt });

                return;
            }
        }
        // 没有手机号，展示输入框
        !showMobile && this.setState({
            showMobile: true
        });
    }
}

class SeatList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            scale: 1,
            translateY: 0,
            translateX: 0,
            seatList: [{}],
            canvasSize: {
                width: 0,
                height: 0
            }
        };
        this.scroll = this.scroll.bind(this);
    }
    render() {
        const { data, row_len, sel_seat, seat_img, show_best, openPartition, seatPartition } = this.props;
        const rowCount = data?.format.length;
        return (
            <View style={ st.wrap_seat }>
                {
                    // 渲染座位图
                    this.seatComponents(openPartition)
                }
                { data ? <View style={ {
                		flex: 1,
		                flexDirection: 'row',
		                overflow: 'auto',
		                paddingTop: pt(rowCount > 20 ? (rowCount-20) * 13 : 0)
                } }>
                        {(data?.format && data?.format?.length < 30)
                            ? <View style={ {
                                width: pt(16),
                                zIndex: 3,
                                justifyContent: 'center',
                                paddingLeft: pt(2),
                                marginTop: -pt(-22)
                            } }>
                                <LineTip data={ data?.format } { ...this.state } />
                            </View>
                            : null}

                        <View style={ { flex: 1,  marginTop: pt(23) } }>
                            <SeatItem
                                data={ data?.format }
                                row_len={ row_len }
                                sel_seat={ sel_seat }
                                scroll={ this.scroll }
                                seat_img={ seat_img }
                                show_best={ show_best }
                                seatPartition={ seatPartition }
                                openPartition={ openPartition }
                                hallName={data ? data.hallName : ''}
                                canvasSize={ (e)=>  this.setState({ canvasSize: e }) }
                            />
                        </View>
                    </View> : <Loading contentStyle={ { flex: 1 } } />}
                {/*座位底部固定区域*/}
                {
                    this.bottomFixed()
                }
            </View>
        );
    }

    /**
     * 顶部银幕显示 !!!
     * @returns { JSX.Element }
     */
    seatComponents(openPartition = false){
	    const { translateX, scale , viewingArea} = this.state;
	    const { data, seatPartition, show_best, has_db } = this.props;
	    // 是否显示座位分布
	    return (
		    <View style={ [st.seat_bg, st.bgt_color] }>
			    {
				    <View style={{ marginBottom: 0 }}>
					    {
						    <View style={st.align_center}>
							    <>
								    {

									    openPartition ? seatPartition.map((value, index) => {
										    return this.oneFast(getColor(index, seatPartition.length), '¥' + moneyHandle(value.agentSeatAreaName))
									    }) : <></>

								    }
							    </>
							    <>
								    {
									    show_best ? this.oneFast(newImg.optimum, '最佳观影区'): <></>
								    }
							    </>
						    </View>
					    }
					    <View style={[st.align_center, { height: pt(30), marginTop: pt(15) }]}>
						    <JDImage
							    source={{uri: 'https://storage.jd.com/pandoracdn/movie/image/yingmu.png'}}
							    style={{ width: pt(225), height: pt(20), marginTop: pt(openPartition ? 10 : 5)}}/>
					    </View>
					    <View style={[st.align_center]}>
						    <JDText style={{ fontSize:pt(9), color: 'rgba(51,51,51,0.8)', marginTop: pt(-12.5) }}>
							    { data ? data.hallName : ''}银幕
						    </JDText>
					    </View>
				    </View>
			    }
		    </View>
	    )
    }
    oneFast(img, name, two = false){
        return (
            <View style={[st.fast, {width: pt(60)}]}>
                <JDImage source={{ uri: img }} style={[st.fast_img, two ? {width: pt(26)} : {}]} resizeMode='stretch' />
                <JDText style={{ fontSize: pt(10) }}>{name}</JDText>
            </View>
        )
    }

    // 座位图及底部固定区域
    bottomFixed(){
        const { has_db } = this.props;
        return (
            <View style={[st.align_center, st.bgt_color, { padding: pt(10) }]}>
                <View style={ st.wrap_tip }>
                    <JDImage source={ {uri: newImg.chose}} style={ st.tip_img }  />
                    <JDText style={ st.tip_txt }>可选</JDText>
                    <JDImage source={ {uri: newImg.sold} } style={ st.tip_img }  />
                    <JDText style={ st.tip_txt }>已售</JDText>
                    {
                        has_db  ? <>
                            <JDImage source={ {uri: newImg.lovers}} style={ [st.tip_img, { width: pt(26 )}] } />
                            <JDText style={ st.tip_txt }>情侣座</JDText>
                        </> : <></>
                    }
                    <JDImage source={ {uri: newImg.notOptional}} style={ st.tip_img } />
                    <JDText style={ st.tip_txt }>不可选</JDText>
                </View>
            </View>
        )
    }
    scroll(event) {
        const { scale, translateY, translateX } = event;
        this.setState({
            scale,
            translateY,
            translateX
        });
    }

    componentDidMount() {
    	try{
		    document.querySelector('.seat_map_wrapper').onscroll = () => {
			    setTimeout(() => {
				    document.querySelector('.Tabbar1').style.top = -document.querySelector('.seat_map_wrapper').scrollTop + 42 + 'px';
				    // document.querySelector('.Tabbar').style.left =document.querySelector('.seat_map_wrapper').scrollLeft+'px';
				    document.querySelector('.seat_screen').style.top = document.querySelector('.seat_map_wrapper').scrollTop + 'px';
			    }, 0);
		    };
	    } catch (e) {}
    }

    componentWillUnmount() {
        // window.removeEventListener('scroll', this.bindHandleScroll);
    }
}

class LineTip extends PureComponent {
    constructor(props) {
        super(props);
    }
    render() {
        const { data, translateY, scale } = this.props;
        const height =  this.props?.canvasSize?.height || 0;
        return (
            <View style={ { transform: [ { translateY: translateY * scale }] } }>
                <View style={ [st.seat_num, { height: height * scale } ]}>
		                { data.map((val, key) => {
				                let line = ' ';
				                let height = pt(14.2) * scale;
				                let aisleNumber = 0; // 是否是过道
				                val.forEach((value) => {
						                // 过道
						                if (+value?.format[2] === 2) {
								                aisleNumber++;
						                } else {
								                const value_line = value?.format[1]?.split(':')[0];
								                if (value_line >= 1 || isNaN(value_line - 0)) {
										                line = value_line;
								                }
						                }
				                });
				                if (aisleNumber === val.length){
						                line = ' ';
				                }
				                return (
					                <View style={ [st.wrap_seat_num, {
							                marginBottom: pt(2 * scale),
							                height
					                }] } key={ key }>
							                <JDText style={ [st.num_item, { height }] } >
									                {line}
							                </JDText>
					                </View>
				                );
		                })}
                </View>
            </View>
        );
    }
}

// 座位绘制区域
class SeatItem extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            // gif_loc_list: []
            height: 0,
            width: 0,
            scale: 1
        };
        this.row_num = 0;
        this.sel_random = false;
        this.lock_random_list = null;
        this.select_img_list = null;
        // this.select_gif_list = null;
        this.lock_db_random_list = null;
        this.select_db_img_list = null;

        this.select_img_list_ac = {};
        this.select_db_img_list_ac = {};

        // this.gif = this.gif.bind(this);
        this.set_size = this.set_size.bind(this);
        this.sel = this.sel.bind(this);
        this.scroll = this.scroll.bind(this);
        this.set_scroll = this.set_scroll.bind(this);
    }
    componentWillMount() {
        const { data, row_len } = this.props;
        const {scale} = this.state;
        const col_len = data.length;
        const row_num = ~~(row_len * 0.6);
        const col_num = ~~(col_len / 3);
        const row_left_num = Math.ceil(row_len * 0.2);
        const col_top_num = Math.ceil(col_len / 3);

        this.row_width = pt(((row_num * 16) - 1))
        this.col_height = pt(col_num * 16 - 1)
        this.row_left = pt(((row_left_num * 16) - 2))
        this.col_top = pt((col_top_num * 16) - 2)

        setLog().name('座位数据').add(this, {
            row_num,
            col_num,
            row_left_num,
            col_top_num,
            scale
        });
    }

    render() {
        const { data, acList, seat_img, show_best, openPartition } = this.props;
        const { width, height } = this.state;
        const { col_height, col_top, row_width, row_left, lock_random_list, lock_db_random_list } = this;
        // const {gif_loc_list} = this.state;
        // const {col_height, col_top, row_width, row_left, lock_random_list, select_gif_list } = this;
        const scale = null;
        const lock_img = lock_random_list ? seat_img.lockSeatList : null;
        const lock_db_img = lock_db_random_list ? seat_img.lockDouSeatList : null;
        // setLog().name('座位图').add(data);
        return (
            <ViewTransformer
                style={ [st.wrap_line, {height: height}] }
                maxScale={ 3 }
                minScale={ 1 }
                ref='scale'
                className='ViewTransformer'
                id='ViewTransformer'
                onViewTransformed={ this.scroll }
                // data={data}
                out_scale={ null }
                large={ maxLine >= 22 }
                _height={ height }
                _width={ width }
            >

                <View style={ [st.wrap_rect, scale] } onLayout={ this.set_size } className={'wrap_rect'}>

                    {/* {gif_loc_list.map((val, key) => {

                        let top = val.keys * pt(14);
                        let left = val.key * pt(16.5);
                        top = 0;
                        left = 0;

                        return <JDImage source={{ uri: select_gif_list[~~(Math.random() * select_gif_list.length)] }} style={[st.gif, { top, left }]} resizeMode='contain' key={key} />

                    })} */}


                    {/*选票绘制区域*/}
                    { data.map((val, keys, arr) => {
                        this.line_num = arr.length;
                        this.row_num = 0;
                        return (
                            <View key={ keys } style={ st.srap_line }>
                                { /*// 1 横坐标, 2 真实座位号, 3 座位状态, 4 区域,  5座位号唯一标志,*/ }
                                { val.map((val, key) => {
                                    let source;
                                    let ac = false; // 当前座位是否被选中
                                    let is_db = false;
                                    // acList 表示已选中的座位
                                    acList.forEach((value) => (value.meta === val.meta) && (ac = true));
                                    this.row_num += (val.db_meta ? 2 : 1);
                                    // 根据第四位的区域来绘制座位图;
                                    const localPosition = val?.format[3];
                                    // []
                                    // 过道[]
                                    if (+val?.format[2] === 2) {
                                        return <View style={ [st.seat_img, {backgroundColor: 'transparent'}] } key={ key } />;
                                    }
                                    //0 可售； 1 已售； 3 情侣左可售； 4 情侣右可售； 2 过道等, 5：不可用，13 情侣左已售 14 情侣右已售;
                                    switch (val?.format[2]) {
                                        case '0': // 可售
                                            source = this.select_img(ac, keys, key, localPosition);
                                            break;
                                        case '1': // 已售
                                            source = lock_random_list ? {
                                                uri: lock_img[lock_random_list[keys + key]]
                                            } : img.seat_na;
                                            break;
                                        case '3': // 情侣左可售
                                            source = this.select_db(ac, keys, key, localPosition);
                                            is_db = true;
                                            break;
                                        case '5': // 座位不可用
                                            source = {
                                                uri : newImg.notOptional
                                            }
                                            break;
                                        case '23': // 座位不可用
                                            source = {
                                                uri : newImg.lovers_disabled
                                            }
                                            is_db = true;
                                            break;
                                        case '13': // 情侣左已售
                                            source = lock_db_random_list ? {
                                                uri: lock_db_img[lock_db_random_list[keys + key]]
                                            } : img.db_seat_na;
                                            is_db = true;
                                            break;
                                    };
                                    if (val.self_select) {
                                        if (val.db_meta) {
                                            source = this.select_db(ac, keys, key, localPosition);
                                            is_db = true;
                                        } else {
                                            source = this.select_img(ac, keys, key, localPosition);
                                        };
                                    };

                                    // ac && this.gif(keys, key);

                                    return source
                                        ? (
                                            <TouchableWithoutFeedback key={ key } onPress={ () => this.sel(val, key, keys) } >
                                                {isIOS
                                                    ? <JDImage source={ source } style={ [st.seat_img, is_db && st.db_img] } resizeMode='stretch' />
                                                    : <Image source={ source } style={ [st.seat_img, is_db && st.db_img] } resizeMode='stretch' />
                                                }
                                            </TouchableWithoutFeedback>
                                        )
                                        : null;
                                })}
                            </View>
                        );
                    })}

                    {/*四根红色虚线*/}
                    {show_best && <Dashed width={ row_width } top={ col_top } left={ row_left } style={ st.best } />}
                    {show_best && <Dashed width={ row_width } top={ col_top + col_height } left={ row_left } style={ st.best } />}
                    {show_best && <Dashed width={ col_height } top={ col_top } left={ row_left } vertical={ true } style={ st.best } />}
                    {show_best && <Dashed width={ col_height } top={ col_top } left={ row_left + row_width } vertical={ true } style={ st.best } />}
                </View>
            </ViewTransformer>
        );
    }

    componentDidUpdate(prevProps) {
        // console.log(document.getElementById('seatdiv').offsetWidth,'座位的宽度')
        // console.log(document.getElementById('ViewTransformer').offsetWidth,'盒子的宽度')
        const { seat_img, acList } = this.props;
        const { lock_random_list, select_img_list, lock_db_random_list, select_db_img_list } = this;
        // const {lock_random_list, select_img_list, select_gif_list } = this;

        const lock_img = (seat_img && seat_img.lockSeatList && seat_img.lockSeatList.length) ? seat_img.lockSeatList : null;

        const lock_db_img = (seat_img && seat_img.lockDouSeatList && seat_img.lockDouSeatList.length) ? seat_img.lockDouSeatList : null;

        const sel_img = (seat_img && seat_img.selectSeatList && seat_img.selectSeatList.length == 4) ? seat_img.selectSeatList : null;

        const sel_db_img = (seat_img && seat_img.selectDouSeatList && seat_img.selectDouSeatList.length == 2) ? seat_img.selectDouSeatList : null;
        // let gif_img = (seat_img && seat_img.selectGifSeatList && seat_img.selectGifSeatList.length) ? seat_img.selectGifSeatList : null;

        let temp_lock;

        let temp_lock_db;

        if (lock_img && !lock_random_list) {
            temp_lock = new Array(800).join('|').split('|').map(() => {
                return ~~(Math.random() * lock_img.length);
            });

            this.lock_random_list = temp_lock;

            this.forceUpdate();
        };

        if (lock_db_img && !lock_db_random_list) {
            temp_lock_db = new Array(800).join('|').split('|').map(() => {
                return ~~(Math.random() * lock_db_img.length);
            });

            this.lock_db_random_list = temp_lock_db;

            this.forceUpdate();
        };

        if (seat_img && seat_img.selectRule == 2) {
            this.sel_random = true;
        };
        if ((sel_db_img && !select_db_img_list)) {
            this.select_db_img_list = sel_db_img.map((val, key) => {
                return { uri: val, order: key };
            });

            this.forceUpdate();
        };

        if ((sel_img && !select_img_list)) {
            this.select_img_list = sel_img.map((val, key) => {
                return { uri: val, order: key };
            });

            this.forceUpdate();
        };

        if (acList.length && !prevProps.acList.length) {
            if (acList.length != 1) {
                this.set_scroll(acList[1]);
            } else {
                this.set_scroll(acList[0]);
            };
        };

        // if ((gif_img && !select_gif_list)) {
        //     this.select_gif_list = gif_img;
        //     this.forceUpdate();
        // };
    }

    set_scroll(item) {
        const { width, height, scale } = this.state;

        const { line_num, row_num } = this;

        const index = item?.format[0]?.split(':');

        const cx = ~~(row_num) / 2;

        const cy = ~~(line_num) / 2;

        let scroll_x = (width / row_num) * (cx - index[1]);

        let scroll_y = (height / line_num) * (cy - index[0]);

        if (scale == canvasZoom && !recom_sel) return;

        if (Math.abs(scroll_x) <= (width / row_num * 4)) {
            scroll_x = 0;
        };

        if (Math.abs(scroll_y) <= (height / line_num * 5)) {
            scroll_y = 0;
        };

        this.refs.scale.updateTransform({
            scale: canvasZoom,
            translateX: scroll_x,
            translateY: scroll_y
        });
    }

    scroll(event) {
        const { scroll } = this.props;
        const { scale } = event;

        scroll(event);

        this.setState({ scale });
    }

    sel(val, key, keys) {
        recom_sel = false;
        this.props.sel_seat(val);
        // this.gif(keys, key, ac)
    }

    set_size(e) {
        const config = {
            height: e.nativeEvent.layout.height,
            width: e.nativeEvent.layout.width
        }
        setLog().name('画布大小').add(config)
        this.props.canvasSize &&  this.props.canvasSize(config)
        this.setState(config);
    }

    gif(keys, key, ac) {
        // setTimeout(() => {
        //     if (show_gif && !ac) {
        //         if (this.select_gif_list && this.select_gif_list.length) {
        //             this.setState({
        //                 gif_loc_list: [{ keys, key }]
        //             }, () => {
        //                 setTimeout(() => {
        //                     this.setState({
        //                         gif_loc_list: []
        //                     })
        //                 }, 2000);
        //             });
        //         };
        //         show_gif = false;
        //     };
        // }, 300);
    }

    /**
     * 情侣座被选中
     * @param ac 当前座位是否选中
     * @param keys 第几排的序号
     * @param key 第几行的序号
     * @param localPosition 分区
     * @returns {*|{uri}}
     */
    select_db(ac, keys, key, localPosition = '') {
        const {
            seatPartition, // 分区价格
            openPartition, // 是否有分区
        } = this.props;
        const { select_db_img_list, select_db_img_list_ac, sel_random } = this;
        const index = `${keys}_${key}`;
        // 已经被选中的情侣座
        const index_in_ac = select_db_img_list_ac[index];
        if (select_db_img_list) {
            if (ac) {
                if (index_in_ac) { return { uri: index_in_ac.uri }; };
                const uri = sel_random ? select_db_img_list[~~(Math.random() * select_db_img_list.length)] : select_db_img_list.shift();
                if (!uri) {
                    return img[`db_seat${ac ? '_ac' : ''}`];
                }
                select_db_img_list_ac[index] = uri;
                return { uri: uri.uri };
            }

            if (index_in_ac) {
                if (!sel_random) {
                    select_db_img_list.push(index_in_ac);
                    select_db_img_list.sort((a, b) => {
                        return a.order - b.order;
                    });
                }
                select_db_img_list_ac[index] = null;
            };

            return img.db_seat;
        }
        // 情侣座未选中
        if (!ac && openPartition) {
            // 查找索引绘制
            const findIndex = seatPartition.findIndex(value => value.agentSeatAreaId === localPosition);
            if (findIndex !== -1) {
                const drawImg = getColor(findIndex, seatPartition.length, true)
                return {
                    uri: drawImg
                }
            }
        }
        return img[`db_seat${ac ? '_ac' : ''}`];
    }

    /**
     * 普通座位渲染
     * @param ac
     * @param keys
     * @param key
     * @param localPosition
     * @returns {*|{uri: string}|{uri}}
     */
    select_img(ac, keys, key, localPosition) {
        const {
            seatPartition, // 分区价格
            openPartition, // 是否有分区
        } = this.props;
        const { select_img_list, select_img_list_ac, sel_random } = this;
        const index = `${keys}_${key}`;
        const index_in_ac = select_img_list_ac[index];
        if (select_img_list) {
            // 当前被选中了进入
            if (ac) {
                if (index_in_ac) { return { uri: index_in_ac.uri }; };
                const uri = sel_random ? select_img_list[~~(Math.random() * select_img_list.length)] : select_img_list.shift();
                select_img_list_ac[index] = uri;
                return { uri: uri.uri };
            }
            if (index_in_ac) {
                if (!sel_random) {
                    select_img_list.push(index_in_ac);
                    select_img_list.sort((a, b) => {
                        return a.order - b.order;
                    });
                }
                select_img_list_ac[index] = null;
            };

            return img.seat;
        };
        // 当前是否被选中[并且开启了分区]
	      console.log('openPartition', openPartition)
        if (!ac && openPartition) {
            // 查找索引绘制
            const findIndex = seatPartition.findIndex(value => value.agentSeatAreaId === localPosition);
            if (findIndex !== -1) {
                const drawImg = getColor(findIndex, seatPartition.length)
                return {
                    uri: drawImg
                }
            }
        }
        return img[`seat${ac ? '_ac' : ''}`];
    }

    componentDidUpdate() {
        // 设置屏幕位置居中
		    try {
			    document.querySelector('.seat_bg').style.width = document.querySelector('.ViewTransformer').offsetWidth - pt(20) + 'px';
		    }catch (e) {}
    }

    componentDidMount() {
    	  try{
		      document.querySelector('.seat_bg').style.width = document.querySelector('.ViewTransformer').offsetWidth - pt(20) + 'px';
		      // document.querySelector('.seat_map_wrapper').scrollLeft =  document.querySelector('.ViewTransformer').offsetWidth/4
		      document.querySelector('.seat_map_wrapper').scrollLeft = document.querySelector('.seat_screen').offsetLeft - 100;
		      // this.loaded();
		      // this.pinch();
		      // this. etool();
		      const _this = this;
		      _this.refs.scale.updateTransform({
			      scale: canvasZoom
		      });
		      console.log(this.props.data.length, 'length');
	      } catch (e) {}

    }
}
// 头部信息区域
class Info extends PureComponent {
    render() {
        let {
					movieName,
	        theDate,
	        startTime,
	        playType,
	        hallName,
	        has_db,
	        show_best,
	        stopSaleMinute,
	        minTicketNum
				} = this.props;
        theDate = theDate ? theDate.split('-').map(val => complement(val - 0)).join('-') : '';
        const trim = trim_time(new Date(theDate) - 0);
        const cur = trim_time(new Date() - 0);
        const today = !(trim - cur) && '今天';
        const day = ms_to_week(new Date(theDate) - 0);
	      const showMinTicketNum = (minTicketNum > 0)

        return (
	        <View style={ st.top_new }>
			        <View  style={ showMinTicketNum ? st.top_l: {} }>
				        {/* //is_web */}
				        <JDText style={ st.mov_name } numberOfLines={ 1 }>{ decodeURI(movieName) || ' '}</JDText>
				        <JDText style={ st.mov_info } numberOfLines={ 1 }>
					        {theDate.split('-')[1]}-{theDate.split('-')[2]}({today || day}) | {startTime} | { decodeURI(playType)} | { decodeURI(hallName)}
				        </JDText>
				        {/*可选已售状态迁移到座位图底部*/}
			        </View>
			        {
				        showMinTicketNum && (
					        <View style={ st.top_r }>
						        <JDText style={ st.mov_name_start }>{minTicketNum}人开场</JDText>
						        <JDText style={ st.mov_info }>{stopSaleMinute}</JDText>
					        </View>
				        )
			        }
	        </View>
        );
    }
}

class Bottom extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            show_clear: false
        };
        this.sub = this.sub.bind(this);
        this.tel = this.tel.bind(this);
        this.clear_itp = this.clear_itp.bind(this);
    }

    render() {
        let {
            showMobile,
            acList,
            mobileNum,
            show_recom,
            price,
            recom,
            del,
            promotion,
            openVerifyPop,
            verifyMsg,
            openPartition,
            seatOrientation,
            data,
            govSubsidy
        } = this.props;
        const { show_clear } = this.state;
        const seats = [];
        let WrapComponent = View;
        let total = 0;
        let pro = false;
        acList.forEach((val) => {
                seats.push(val.meta);
                if (val.db_meta) {
                        seats.push(val.db_meta);
                };
        });
        acList.sort((a, b) => {
                const cur = a?.format[0]?.split(':');
                const next = b?.format[0]?.split(':');
                if (cur[0] == next[0]) {
                        return cur[1] - next[1];
                };
                return cur[0] - next[0];
        });
        if (seats.length) {
                // 是否开启[分区]
                if (openPartition) {
                        let totalCount = 0;
                        // 动态计算总价格
                        acList.map(value=> {
                                const dbPrice = (value.db_meta ? 2: 1);
                                totalCount += (value.price * dbPrice)
                        })
                        total = moneyHandle(totalCount);
                        // 兼容处理, 若是遇到有优惠开启但是没有找到的情况
                } else {
                        console.log('data', data, acList);
                        const moviePromotionVO = data?.moviePromotionVO;
                        const limitNumber = moviePromotionVO?.limitNumber || 1;
                        acList.map((value, index)=> {
                                // 非分区有优惠时候显示
                                const dbPrice = (value.db_meta ? 2: 1);
                                if (index < Number(limitNumber) && moviePromotionVO) {
                                        const totalBase = Number(data?.jdPrice) - Number(moviePromotionVO?.promotPrice || 0);
                                        total += totalBase * dbPrice;
                                } else {
                                        total += Number(data?.jdPrice) * dbPrice;
                                }
                        })
                        total = moneyHandle(total);
                }
        }
        price = (price / 100).toFixed(2) - 0;
        if ((price + '').indexOf('.') < 0) {
                price = ~~price;
        };
        WrapComponent = KeyboardAvoidingView;
        console.log('acList-666', acList, promotion);

        return (
            <WrapComponent style={ st.wrap_bottom } behavior={ isIOS ? 'padding' : null }>
                {this.props.isTipShow &&
                    <JDTouchable onPress={ this.showPop }>
                        <View style={ st.rz_contain }>
                            <View style={ st.box_row }>
                                <JDImage style={ st.img_smrz } source={ {
                                    uri: 'https://m.360buyimg.com/mobilecal/jfs/t1/145926/20/3596/922/5f1a53bfEf260a775/78fb438eb87246ae.png'
                                } } />
                                <JDText style={ st.txt_smzr }>已完成京东实名认证账号可购票</JDText>
                            </View>
                            <JDImage style={ st.img_right } source={ {
                                uri: 'https://m.360buyimg.com/mobilecal/jfs/t1/115415/23/13226/645/5f1a53bfE85a23a53/95aecb7f92e4d240.png'
                            } } />
                        </View>
                    </JDTouchable>
                }
                { /* 1 横坐标, 2 真实座位号, 3 座位状态, 4 区域,  5座位号唯一标志,*/ }
                { /*0 可售； 1 已售； 3 情侣左可售； 4 情侣右可售； 2 过道等, 5：不可用，13 情侣左已售 14 情侣右已售;*/}
                {!!acList.length && <View style={ [st.has_sel, !showMobile && st.mb9] }>
                    <JDText style={ st.sel_title }>已选座位</JDText>
                    <View style={ st.wrap_has_item }>
                        { acList.map((val, key) => {
		                        const { format } = val;
		                        let seat;
		                        seat = format[1]?.split(':');
		                        const formatTwo = +format[2];
		                        // 若是开启了分区, 优惠用这个来计算[有促销]
		                        let newPrice = 0;
		                        if (openPartition) {
				                        pro = val.showPromotions;
				                        newPrice = val?.price ? moneyHandle(val?.price) : price;
		                        } else {
				                        // 没开分区,优惠给前N张
				                        newPrice = price;
				                        if (promotion?.limitNumber) {
						                        pro = key < promotion.limitNumber;
						                        if (pro) {
								                        // 若是开启优惠,则显示金额为京东价 - 促销金额
								                        newPrice = moneyHandle((Number(promotion.jdPrice) - Number(promotion.promotPrice)));
						                        }
				                        }
		                        }
		                        // 座位计算
		                        const firstSeat = seat[1];
		                        // 临时处理座位问题,若是A则修改为B
		                        let seatCalculation = complement(seat[1] - 0 + (seatOrientation ? 1 : -1));
		                        if (firstSeat.indexOf('A') !== -1) seatCalculation = firstSeat.replace('A', 'B');
                            return (
                                <View style={ { flexDirection: 'row' } } key={ key } >
                                    <JDTouchable style={ st.has_item } onPress={ () => del(val) }>
                                        <JDText style={ st.seat_text }>{seat[0]}排{complement(seat[1])}座</JDText>
                                        <View style={ st.wrap_promotion }>
                                            <JDText style={ st.pri_text }>&yen;{newPrice || price}</JDText>
                                            {pro
                                                ? <View style={ [st.wrap_promotion_txt, govSubsidy === "true" ? st.greenWrapPromotionTxt : ''] }>
                                                    <JDText style={ st.promotion_txt }>惠</JDText>
                                                </View>
                                                : null}
                                        </View>
                                        <JDText style={ st.del_seat_text }>&times;</JDText>
                                    </JDTouchable>
                                    {(formatTwo === 3 || formatTwo === 13) && <JDTouchable style={ st.has_item } onPress={ () => del(val) }>
                                        <JDText style={ st.seat_text }>{seat[0]}排{ seatCalculation }座</JDText>
                                        <View style={ st.wrap_promotion }>
                                            <JDText style={ st.pri_text }>&yen;{newPrice || price}</JDText>
                                            {pro
                                                ? <View style={ [st.wrap_promotion_txt, govSubsidy === "true" ? st.greenWrapPromotionTxt : ''] }>
                                                    <JDText style={ st.promotion_txt }>惠</JDText>
                                                </View>
                                                : null}
                                        </View>
                                        <JDText style={ st.del_seat_text }>&times;</JDText>
                                    </JDTouchable>}
                                </View>
                            );
                        })}
                    </View>
                </View>}

                {(!acList.length && show_recom) && <View style={ st.recom }>
                    <JDText style={ st.recom_title }>推荐座位</JDText>
                    {[1, 2, 3, 4].map((val, key) => {
                        return (
                            <JDTouchable style={ st.recom_item } key={ key } onPress={ () => recom(val) }>
                                <JDText style={ st.recom_item_txt }>{val}人</JDText>
                            </JDTouchable>
                        );
                    })}
                </View>}

                {!!showMobile &&
                <View style={ [st.recom, { height: pt(50) }] }>
                    <JDText style={ st.tel_title }>联系电话</JDText>
                    <JDTextInput
                        inputMode='adjustPan'
                        style={ st.tel_input }
                        placeholder='请输入11位电话号码'
                        underlineColorAndroid='transparent'
                        maxLength={ 11 }
                        placeholderTextColor='#bbb'
                        value={ mobileNum }
                        keyboardType={ isIOS ? 'numbers-and-punctuation' : 'numeric' }
                        onChangeText={ this.tel }
                        onFocus={ () => {
                            mta('InputPhone', 'Positon');
                            this.setState({ show_clear: true });
                        } }
                        onBlur={ () => { this.setState({ show_clear: false }); } }
                        iosreturnKeyType='done'
                        returnKeyLabel='确认'
                    />

                    {(mobileNum && show_clear && !isIOS)
                        ? <JDTouchable style={ st.clear_input } onPress={ this.clear_itp }>
                            <JDImage source={ img.close } style={ st.clear_input_img } />
                        </JDTouchable>
                        : null}

                </View>}

                <LinearGradient
                    colors={ ['#F10000', '#FF2000', '#FF4F18'] }
                    style={ [st.wrap_sub, seats.length && { opacity: 1 }] }
                    start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                    <JDTouchable style={ st.sub } onPress={ this.sub } underlayColor='#FF4F18'>
                        {seats.length
                            ? <JDText style={ st.sub_txt }>&yen;{total} 确认选座</JDText>
                            : <JDText style={ st.sub_txt }>请先选座</JDText>
                        }
                    </JDTouchable>

                </LinearGradient>

            </WrapComponent>
        );
    }

    // 解决微信浏览器在iphoneXR上键盘弹回内容不回弹的BUG
    changeBlur() {
        const u = navigator.userAgent; const app = navigator.appVersion;

        const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

        if (isIOS) {
            setTimeout(() => {
                const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;

                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 200);
        }
    }

    componentDidMount() {
        storage.load({
            key: 'seatPhone'
        }).then(() => {
            // this.props.dispatch({ type: 'mobileNum', mobileNum: res })
            this.props.dispatch({ type: 'mobileNum', mobileNum: decrypt(fetchLocal('savemobile'), 'y97c51kl38h8p144') });
        }).catch(() => { });
    }

    showPop = () => {
        this.props.openVerifyPop && this.props.openVerifyPop();
    }

    showPop = () => {
        this.props.openVerifyPop && this.props.openVerifyPop();
    }

    clear_itp() {
        this.props.dispatch({ type: 'mobileNum', mobileNum: '' });
        // saveLocal('savemobile','');
    }

    tel(mobileNum) {
        mobileNum = mobileNum.trim();

        const reg = /^[1]\d*$/g;

        if (reg.test(mobileNum) || !mobileNum) {
            this.props.dispatch({ type: 'mobileNum', mobileNum });
        };
    }
    // 确认选座表单提交
    sub() {
        let {
            dispatch,
            acList,
            planId,
            mobileNum,
            selectSeats,
            theDate,
            price,
            startTime,
            promotion,
            show_alert,
            data,
            show_pay,
            openPartition,
	        scheduledPlay,
            govSubsidy,
            govSubsidyText,
            govSubsidyTag
        } = this.props;
        const seats = [];
        // 座位和价格的对应关系
        const seatsGroup = [];
        // 分区数组信息
        let promoInfo = [];
        if (submit) return;
        if (acList.length) {
            mta('PositionSure', 'Positon', `${data.cinemaId || ''}_${data.jSkuId || ''}_${data.movieId || ''}`);
            JDMta.savePageInfoWithSKU(data.jSkuId || '');
            if (!/^[1]\d{10}$/g.test(mobileNum)) {
                tip('请输入正确的手机号码');
                return;
            };

            // storage.save({
            //     key: 'seatPhone',
            //     data: mobileNum
            // });

            saveLocal('savemobile', encrypt(mobileNum, 'y97c51kl38h8p144'));
            storage.save({
                key: 'seatPhone',
                data: mobileNum
            });

		        // 提单参数拼装[提交]
		        const addParameter = (val) => {
				        const jdPrice = val.discount?.jdPrice || 0;
				        const promotPrice = val.discount?.promotPrice || 0;
				        // 促销
				        const promoDiscountPrice = jdPrice - promotPrice;
				        return {
						        seat: val.meta,
						        promoId: val.discount?.actId || 0,
						        skuId: val.discount?.jskuId || '',
						        rfId: val.discount?.rfId || '',
						        promoDiscountPrice: promoDiscountPrice,
						        showPromotions: val.showPromotions, // 是否有优惠
				        }
		        }
		        // 下一页[电影兑换券]使用的参数
		        const addParameterNext = (val, index, isDb = false)=> {
				        const { seatsData } = this.props;
				        let dbMeta = val.meta;
				        if (isDb) {
						        // 若是情侣座, 查找他的下一个座位
						        seatsData.map(value => {
								        value.map((next) => {
										        // 找到情侣座的另一个
										        if (next.meta === val.meta) dbMeta = next.db_meta
								        })
						        })
						        console.log('找到情侣座', dbMeta);
				        }
				        if (openPartition) {
						        return {
								        meta: dbMeta,
								        price: val.price || 0, // 最终支付价
								        originalPrice: val.discount?.jdPrice || 0, // 原价[无优惠]
                        promotPrice: val.price, // 新增字段保持两边一致性[最终支付价]
						        }
				        } else {
						        // 兑换券的实际抵扣金额
						        const moviePromotionVO = data?.moviePromotionVO || {}
						        const limitNumber = moviePromotionVO?.limitNumber || 5;
						        // 原价减去促销的价格
						        const promotPrice = moviePromotionVO
							        ? (Number(moviePromotionVO?.jdPrice) - Number(moviePromotionVO?.promotPrice))
							        : 0;
						        return {
								        meta: dbMeta,
								        price: +data?.jdPrice || 0, // 最终支付价
								        actId: (index < limitNumber) ? moviePromotionVO?.actId : '',
								        promotPrice, //促销价格
						        }
				        }
		        }
		        acList.forEach((val, index) => {
				        seats.push(val.meta);
				        // 开启分区后使用
				        if (openPartition) {
						        promoInfo.push(addParameter(val))
				        }
				        seatsGroup.push(addParameterNext(val, index));
				        if (val.db_meta) {
						        seats.push(val.db_meta);
						        // 开启分区后使用
						        if (openPartition) {
								        promoInfo.push(addParameter(val))
						        }
						        // 情侣座的座位图需要重新计算
						        seatsGroup.push(addParameterNext(val, index, true));
				        };
		        });
		        submit = true;

            dispatch({ type: 'show_loading', show_loading: true });
            // 是否开启分区 存入
            dispatch({ type: 'partition', partition: openPartition ? 1 : 0 });
	          //saveLocal('partition',  openPartition ? 1 : 0)
            // 是否开启分区
            if (openPartition) {
                // 过滤数据, 开启了分区不一定有优惠, 去除没有优惠的!
                promoInfo = promoInfo.filter(value => value?.rfId)
                // 写入支付页面使用的数据
                dispatch({ type: 'promoInfo', promoInfo });
	              //saveLocal('promoInfo', promoInfo)
	              //saveLocal('seatsGroup', seatsGroup)
            }
		        dispatch({ type: 'seatsGroup', seatsGroup });
            // Keyboard.dismiss();

            // 先判断是否开启分区;
            let totalAmount = 0;
		        // 优惠促销个数
		        let promoSeatCount = 0;
            // 开了分区
            if (openPartition) {
                // 总价是原价的累加[情侣座需要*2]
                acList.map(value=> totalAmount += value.jdPrice * (value.db_meta ? 2: 1));
            } else {
		            totalAmount = (price * seats.length).toFixed(2) - 0;
		            // 计算促销个数
		            const moviePromotionVO = data?.moviePromotionVO || {};
		            const limitNumber = moviePromotionVO?.limitNumber || 0;
		            console.log('limitNumber', limitNumber)
		            acList.map((value, index)=> {
				            if (index < Number(limitNumber)) {
						            promoSeatCount++
				            }
		            })
            }
		        console.log('acList-acList', acList)
            const buyFrom = sessionStorage.getItem('buyFrom');
            const channel = sessionStorage.getItem('channel');
            const lockData = {
                planId,
                mobileNum: encrypt(mobileNum, 'y97c51kl38h8p144'),
                seats: seats.join('|'),
                selectedSeat: selectSeats,
                totalAmount: totalAmount,
                buyFrom: +(buyFrom || 9),
                channel: +(channel || 1),
                cinemaId: data.cinemaId,
                // 促销优惠信息[是否开启];
                promoInfo: openPartition ? promoInfo : [],
	              scheduledPlay: +scheduledPlay
            }
            setLog().name('锁座数据').add(lockData);

            // 使用新的锁座方法
            this.lockMovieSeat(
                lockData,
                promoSeatCount,
                govSubsidy,
                govSubsidyText,
                govSubsidyTag
            ).then(success => {
                submit = false;
                dispatch({ type: 'show_loading', show_loading: false });
            }).catch((e) => {
                submit = false;
                dispatch({ type: 'show_loading', show_loading: false });
                tip('系统有点忙，请稍后重试');
            });
        }
    }

    // 锁座方法，支持轮询逻辑
    async lockMovieSeat(lockData, promoSeatCount, govSubsidy, govSubsidyText, govSubsidyTag) {
      try {
          let {
              dispatch,
              acList,
              planId,
              mobileNum,
              selectSeats,
              theDate,
              price,
              startTime,
              promotion,
              show_alert,
              data,
              show_pay,
              openPartition,
              scheduledPlay = "0"
          } = this.props;
          let retryTimes = 0;
          let uuid = null;
          const startTimeMs = Date.now();
          let finalTry = 0;

          while (true) {
              // 构建请求参数
              const requestData = {
                  ...lockData,
                  uuid: uuid,
                  retryTimes: retryTimes,
                  finalTry
              };

              // 调用锁座接口
              const res = await get('lockMovieSeat', requestData, true);

              // 处理错误码
              if (res.errCode === 5000) {
                  tip('系统有点忙，请稍后重试');
                  return false;
              }
              if (res.errCode === 5001 || res.errCode === 5002) {
                  tip(res.errMsg || '系统有点忙，请稍后重试');
                  return false;
              }
              if (res.errCode === 6000) {
                  show_alert();
                  return false;
              }
              if (res.errCode === 2105) {
                  if (res.data && res.data.erpOrderId) {
                      show_pay(res.data.erpOrderId);
                  } else {
                      tip('系统有点忙，请稍后重试');
                  }
                  return false;
              }
              if (res.errCode === 2106) {
                  tip('您有订单正在出票中，暂不可锁座');
                  return false;
              }
              if (res.errCode === 2103) {
                  tip('操作太快了，休息一下再试试');
                  return false;
              }
              if (res.errCode === 2107) {
                  tip('本场次价格调整中，请返回场次列表重新选择');
                  return false;
              }
              if (res.errCode === 2600) {
                  dispatch({ type: 'show_lockErrorPop', show_lockErrorPop: true });
                  return false;
              }

              // 处理成功响应
              if (!res.data) {
                  return false;
              }

              // 检查是否需要轮询
              if (res.data.retryCode === 2 && finalTry === 0) {
                  // 需要继续轮询
                  uuid = res.data.uuid || uuid;
                  const maxRetryTimeMs = res.data.maxRetryTimeMs || 6000;
                  const retryIntervalMs = res.data.retryIntervalMs || 800;

                  // 检查是否超时
                  const currentTimeMs = Date.now();
                  const elapsedTimeMs = currentTimeMs - startTimeMs;

                  if (elapsedTimeMs >= maxRetryTimeMs) {
                      // 超时，发起最后一次调用
                      finalTry = 1;
                      retryTimes++;
                      continue;
                  }

                  // 等待指定时间后继续轮询
                  await new Promise(resolve => setTimeout(resolve, retryIntervalMs));
                  retryTimes++;
                  continue;
              } else if (res.data.retryCode === 1) {
                  // 锁座成功
                  const { agentOrderId, agentId } = res.data;
                  this.navigateToOrder(agentOrderId, agentId, mobileNum, planId, price, theDate, startTime, promotion, openPartition, promoSeatCount, scheduledPlay, govSubsidy, govSubsidyText, govSubsidyTag);
                  return true;
              } else if (res.data.retryCode === 3) {
                  // 锁座失败
                  tip(res.errMsg || '锁座失败，请稍后重试');
                  return false;
              } else {
                  // 其他情况，按原有逻辑处理
                  const { agentOrderId, agentId } = res.data;
                  this.navigateToOrder(agentOrderId, agentId, mobileNum, planId, price, theDate, startTime, promotion, openPartition, promoSeatCount, scheduledPlay, govSubsidy, govSubsidyText, govSubsidyTag);
                  return true;
              }
          }
      } catch (error) {
          tip('系统有点忙，请稍后重试');
          return false;
      }
  }

  // 跳转到订单页
  navigateToOrder(agentOrderId, agentId, mobileNum, planId, price, theDate, startTime, promotion, openPartition, promoSeatCount, scheduledPlay, govSubsidy, govSubsidyText, govSubsidyTag) {
    global.orderState = null;
    global.isFirst = false;
    call.event.off('order');
    is_jump = true;
    is_web && promotion ? this.context.router.toOrder({
          mobileNum: encrypt(mobileNum, "y97c51kl38h8p144"),
          // mobileNum,
          agentOrderId,
          agentId,
          planId,
          price,
          theDate,
          startTime,
          // 促销信息
          limitNumber: promotion && promotion.limitNumber,
          rfId: promotion && promotion.rfId,
          promoDiscountPrice: promotion && promotion.promotPrice,
          promoId: promotion && promotion.actId,
          activityType: promotion && promotion.activityType,
          jskuId: promotion && promotion.jskuId,
          partition: openPartition ? 1 : 0, // 是否开启分区
          promoSeatCount,
          scheduledPlay: +scheduledPlay,
          govSubsidy,
          govSubsidyText, 
          govSubsidyTag
    })
    :
    this.context.router.toOrder({
          mobileNum:encrypt(mobileNum,"y97c51kl38h8p144"),
          // mobileNum,
          agentOrderId,
          agentId,
          planId,
          price,
          theDate,
          startTime,
          partition: openPartition ? 1 : 0, // 是否开启分区
          promoSeatCount,
          scheduledPlay: +scheduledPlay,
          govSubsidy,
          govSubsidyText, 
          govSubsidyTag
      // 促销信息
      // limitNumber: promotion && promotion.limitNumber,
      // rfId: promotion && promotion.rfId,
      // promoDiscountPrice: promotion && promotion.promotPrice,
      // promoId: promotion && promotion.actId,
      // activityType: promotion && promotion.activityType,
      // jskuId: promotion && promotion.jskuId
    });
  }
}

Seat.contextTypes = {
    router: PropTypes.object
};

Bottom.contextTypes = {
    router: PropTypes.object
};

// 座位图片;
const img = {
    seat_tip: require('../img/seat-new/seat_tip.png'),
    db_seat_tip: require('../img/seat-new/db_seat_tip.png'),
    seat_na_tip: require('../img/seat-new/seat_na_tip.png'),
    seat: require('../img/seat-new/seat.png'), // 空白座位
    seat_na: require('../img/seat-new/seat_na.png'), // 已选已卖出去
    seat_ac: require('../img/seat-new/seat_ac.png'), // 选中
    db_seat: require('../img/seat-new/db_seat.png'), // 情侣座
    db_seat_na: require('../img/seat-new/db_seat_na.png'),// 情侣座已卖出去
    db_seat_ac: require('../img/seat-new/db_seat_ac.png'), // 情侣座已选中
    best: require('../img/seat-new/best.png'),
    bg: require('../img/seat-new/movie.png'),
    close: require('../img/close.png')
};

const select = (state) => {
    const props = state.seat;
    return {
        acList: props.acList,
        mobileNum: props.mobileNum,
        show_loading: props.show_loading,
        show_lockErrorPop: props.show_lockErrorPop,
        show_pop: props.show_pop
    };
};

SeatItem = connect(select, null, null, { withRef: true })(SeatItem);
export default connect(select, null, null, { withRef: true })(Seat);